var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"ordered-list"},_vm._l((_vm.items),function(text,i){return _c('li',{key:i,staticClass:"ordered-list__item ml-20",class:{
      'mt-20': i !== 0,
      'ordered-list__item--lower-latin' : _vm.styleTypeLowerLatin
    }},[_c('span',{staticClass:"txt--color-03 txt--weight-500 txt--16px txt--height-20px",domProps:{"innerHTML":_vm._s(text)}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }